import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries.paymentType;

export const PaymentTypeColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => (
    <RedoTableTextCell
      text={
        (row?.paymentGateways || []).length
          ? Array.from(row?.paymentGateways || []).join(", ")
          : ""
      }
    />
  ),
  width: catalogEntry.defaultWidth,
};
